import * as actionTypes from "../actionTypes";

let SAC = (type, payload) => {
  return {
    type: actionTypes[type],
    payload,
  };
};

export const searchBarChange = (searchValue) => {
  return SAC("SEARCH_SEARCH_BAR", searchValue);
};
export const startDateChange = (date) => {
  return SAC("SEARCH_START_DATE", date);
};
export const endDateChange = (date) => {
  return SAC("SEARCH_END_DATE", date);
};

export const searchNotFound = (isOrder) => {
  return SAC("SEARCH_NOT_FOUND", isOrder);
};
export const searchPage = (page) => {
  return SAC("SEARCH_PAGE", page);
};
export const searchPerPage = (perPage) => {
  return SAC("SEARCH_PERPAGE", perPage);
};
